import { render } from "./ColorSwatches.vue?vue&type=template&id=5753c926&scoped=true"
import script from "./ColorSwatches.vue?vue&type=script&lang=js"
export * from "./ColorSwatches.vue?vue&type=script&lang=js"

import "./ColorSwatches.vue?vue&type=style&index=0&id=5753c926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5753c926"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
